export const getTaskFilters = state => state.task.taskFilters;

export const getTaskGridSortCriteria = state => state.task.taskGridSortCriteria;
